import "../../modals/Modal.css";
import { Order } from "../../../../api/orders";
import { getFormattedDate } from "../../utils/getFormattedDate";
import ScrollableContainer from "../../components/ScrollableContainer";

type OrderedProductsTableProps = {
  order?: Order;
};

const OrderedProductsTable = ({ order }: OrderedProductsTableProps) => {
  const id = order?.id;
  const formattedDate = getFormattedDate(order?.createdAt);
  const deliveryMethod = order?.deliveryMethod;
  const shippingPrice = order?.shippingPrice ?? 0;
  const orderStatus =
    order?.status === "Done"
      ? "Finished"
      : order?.status === "Canceled"
        ? "Canceled"
        : "Pending";
  const orderStatusColorClass =
    orderStatus === "Finished"
      ? "order-done"
      : orderStatus === "Canceled"
        ? "order-canceled"
        : "order-pending";
  const products =
    order &&
    order.products.map((product) => {
      return (
        <tr key={product.productName}>
          <td className="td capitalized">{product.productName}</td>
          <td className="td ">{product.quantity} kg</td>
          <td className="td ">{product.unitPrice} kr/kg</td>
          <td className="td ">{product.totalPrice} kr</td>
        </tr>
      );
    });
  return (
    <div>
      <h4 className="order-number">Order ID: {id}</h4>
      <div className="order-details-container">
        <ScrollableContainer>
          <table className="table ">
            <thead>
              <tr>
                <th className="th">Product</th>
                <th className="th">Quantity</th>
                <th className="th">Unit Price</th>
                <th className="th">Sum</th>
              </tr>
            </thead>
            <tbody>{products}</tbody>
            <tfoot>
              <tr>
                <td className="td td-left" colSpan={4}>
                  Subtotal : {order?.totalPrice} kr
                </td>
              </tr>
              {deliveryMethod === "shipping" && shippingPrice > 0 && (
                <tr>
                  <td className="td td-left" colSpan={4}>
                    Delivery: {shippingPrice} kr
                  </td>
                </tr>
              )}
              {deliveryMethod === "pickup" && (
                <tr>
                  <td className="td td-left" colSpan={4}>
                    Pickup: Free
                  </td>
                </tr>
              )}
              <tr>
                <td className="td td-left" colSpan={4}>
                  <span className="bold">
                    Total: {order ? order.totalPrice + shippingPrice : null} kr
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
          <table className="table print-footer">
            <tfoot>
              <tr>
                <td className="td td-left" colSpan={4}>
                  Subtotal : {order?.totalPrice} kr
                </td>
              </tr>
              {deliveryMethod === "shipping" && shippingPrice > 0 && (
                <tr>
                  <td className="td td-left" colSpan={4}>
                    Delivery: {shippingPrice} kr
                  </td>
                </tr>
              )}
              <tr>
                <td className="td td-left" colSpan={4}>
                  <span className="bold">
                    Total: {order ? order.totalPrice + shippingPrice : null} kr
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </ScrollableContainer>
      </div>
      <p className="gray-text business-vat-info"> *All prices exclude VAT</p>
      <div className="info-card"> Order Placed: {formattedDate}</div>
      <div className={orderStatusColorClass + " tag"}>{orderStatus}</div>
    </div>
  );
};

export default OrderedProductsTable;
